var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11C22.5 17.0751 17.5751 22 11.5 22C5.42485 22 0.5 17.0751 0.5 11C0.5 4.92485 5.42485 0 11.5 0C17.5751 0 22.5 4.92485 22.5 11ZM13.7819 5.00518L9.22921 9.34215C9.08121 9.48312 8.97693 9.66373 8.92884 9.86239L7.44921 15.9736C7.19727 17.0141 8.45948 17.7175 9.21808 16.9948L13.7707 12.6578C13.9187 12.5168 14.0229 12.3362 14.071 12.1376L15.5507 6.0264C15.7998 4.99746 14.5486 4.2747 13.7819 5.00518ZM11.5 9.58064C10.7161 9.58064 10.0806 10.2161 10.0806 11C10.0806 11.7839 10.7161 12.4194 11.5 12.4194C12.2839 12.4194 12.9194 11.7839 12.9194 11C12.9194 10.2161 12.2839 9.58064 11.5 9.58064Z",
    fill: "#55BCB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.07685c5adea8ffa3e12214006d73df39.svg";
export { ForwardRef as ReactComponent };